module.exports = __webpack_public_path__ + "media/100-days-of-dante-poster.2f66f495.mp4";